// @flow

import type {TreeStructure} from '../typedef';

export const getAllIds = (data: TreeStructure): Array<string> =>
    data.reduce((acc, item) => {
        if (!item.transient) {
            acc.push(item.id);
        }
        if (item.children) {
            const children = getAllIds(item.children);
            acc = acc.concat(children);
        }
        return acc;
    }, []);
